<!-- Container-fluid starts-->
<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>

    <div *ngIf="!accessdenied" class="user-profile social-app-profile">
        <div class="row">
            <div class="col-sm-12 social-app-tab">
                <div class="card hovercard mb-0">
                    <div class="cardheader socialheader" [ngStyle]="{'background-image': group.coverPhoto}"></div>
                    <div class="user-image">
                        <div class="avatar"><img  style ="position: absolute; left: 15px;" alt="" [src]="group.logo"></div>
                    </div>
                    <div class="info market-tabs p-0">
                        <div style="background-color: white; padding: 20px;padding-top:35px">
                            <div class="title" style="background-color: white;"><a>{{group.title}}</a></div>
                            <div class="desc mt-2" style="background-color: white; text-transform: inherit;">{{group.description}}</div>
                        </div>
                        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" style="box-shadow: none">
                            
                            <li [ngbNavItem]="1">
                                <a style=" padding: 10px; height: 50px;" ngbNavLink>Wall</a>
                                <ng-template ngbNavContent>
                                    <div class="tab-pane fade show" id="timeline" role="tabpanel" aria-labelledby="timeline">
                                        <div class="row">
                                            <app-post-list [relatedTo]="'groups'" [relatedId]="id" [isNewsFeed]="'false'"></app-post-list>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2">
                                <a style=" padding: 10px; height: 50px;" ngbNavLink>Content</a>
                                <ng-template ngbNavContent>
                                    <div class="tab-pane fade show" id="about" role="tabpanel" aria-labelledby="about">
                                        <div class="row">
                                            <app-groups-resource-list [groupId]="id"></app-groups-resource-list>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>

                            <li [ngbNavItem]="3">
                                <a style=" padding: 10px; height: 50px;" ngbNavLink>People</a>
                                <ng-template ngbNavContent>
                                    <div class="tab-pane fade show" id="friends" role="tabpanel" aria-labelledby="friends">
                                        <div class="row">
                                            <app-groups-user-list [groupId]="id"></app-groups-user-list>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="nav" class="mt-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!-- Container-fluid Ends-->
